/* eslint-disable no-useless-escape */
import Swal from "sweetalert2";
import { authService } from "../services";
import { alertActions } from "../store/actions/";
import { history } from "./history";
import { constants } from "../Constants";

export function handleResponse(response, isParsingRequired = true) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        history.replace('/');
        authService.logout();
        Swal.fire({
          title: constants.SESSION_EXPIRED_TXT,
          text: constants.LOGIN_AGAIN_TXT,
          icon: 'warning',
          confirmButtonText: constants.OKAY_TEXT
        });
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    
    return isParsingRequired ? data : response;
  });
}

export function handleErrorInApi() {
  let message;
  if (!window.navigator.onLine) {
    message = "Please check your internet connection.";
  } else {
    message = "Something went wrong.";
  }
  return message;
}

export function validationEmail(emailAddress) {
  const re = /^(([^<>*()\[\]{}?+\\.,;:\s@"]+(\.[^<>*()\[\]{}?+\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const email_address_test = re.test(emailAddress);
  return email_address_test;
}

export function format(source, params) {
  // eslint-disable-next-line no-undef
  params.forEach(function (i, n) {
    source = source.replace(new RegExp("\\{" + i + "\\}", "g"), n);
  })
  return source;
}


// WEBPACK FOOTER //
// ./src/helpers/response.js